import React from 'react';
import { get } from 'lodash';
import { Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { showModal } from '../../../redux/error/ErrorAction';
import { hideLoading, showLoading } from '../../../redux/loader/LoaderActions';
import { POST } from '../../../services/rest.service';
import convertJsonToFormData, { agentSchema } from '../../../helpers/helper';
import { getRegYearType } from '../../../helpers/utils';
import ClearingForwardingDocFields from '../../global/ClearingForwardingFormDocFields';
import { getLoggedInUser } from '../../../redux/user/UserActions';

const VerficationModalForm = (props) => {
  const {
    formValues,
    details,
    isEditMode,
    totalShareVal,
    user,
    rightOpen,
    editRight,
    images,
    showDoc,
    deleteRight,
    handleNext,
    onDocumentUpdateSuccess,
  } = props;
  const dispatch = useDispatch();

  return (
    <Formik
      initialValues={{
        incorporation_certificate: get(formValues, 'incorporation_certificate', '') || '',
        rc_no: get(formValues, 'rc_no', '') || '',
        memorandum_article_association: get(formValues, 'memorandum_article_association', '') || '',
        corporate_address_proof: get(formValues, 'corporate_address_proof', '') || '',
        registration_certificate: get(formValues, 'registration_certificate', '') || '',
        registration_certificate_no: get(formValues, 'registration_certificate_no', '') || '',
        registration_application_status: get(formValues, 'registration_application_status', '') || '',
        ctc_cac_1_1: get(formValues, 'ctc_cac_1_1', '') || '',
        cac_2: get(formValues, 'cac_2', '') || '',
        cac_7: get(formValues, 'cac_7', '') || '',
        shareholder: (details.shareholders && get(details.shareholders[0], 'uuid', '')) || '',
        director: (details.directors && get(details.directors[0], 'uuid', '')) || '',
        reg_year: (details.documents && getRegYearType(details.documents)) || '',
        userType: user.type,
        port_of_operation: get(formValues, 'port_of_operation', '') || '',
      }}
      enableReinitialize
      onSubmit={(values, { setSubmitting }) => {
        dispatch(showLoading());
        const payLoad = {
          rc_no: values.rc_no,
          registration_certificate_no: values.registration_certificate_no,
          port_of_operation: values.port_of_operation,
        };

        const fileFields = [
          'incorporation_certificate',
          'memorandum_article_association',
          'corporate_address_proof',
          'registration_certificate',
          'registration_application_status',
          'ctc_cac_1_1',
          'cac_2',
          'cac_7',
        ];

        fileFields.forEach((field) => {
          if (values[field] instanceof File) {
            payLoad[field] = values[field];
          }
        });
        if (user.type === 'clearing_agent') {
          payLoad.clearing_agent_uuid = user.uuid;
        } else {
          payLoad.forwarding_agent_uuid = user.uuid;
        }
        let formData = convertJsonToFormData(payLoad);

        POST(`/users/uploadUserDocs`, formData)
          .then((data) => {
            //console.log('data', data);
            setSubmitting(false);
            onDocumentUpdateSuccess();
            dispatch(getLoggedInUser());
            dispatch(showModal('Documents uploaded successfully', true));
            dispatch(hideLoading());
          })
          .catch((err) => {
            dispatch(showModal(err.message));
            dispatch(hideLoading());
            setSubmitting(false);
          });
      }}
      validationSchema={agentSchema}
    >
      {(renderProps) => {
        const {
          values,
          touched,
          errors,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
        } = renderProps;

        const validateAndNext = () => {
          const missing = [];

          // For clearing agents: check company document and certificate number
          if (user.type === 'clearing_agent') {
            const hasDoc = values.registration_certificate || images?.registration_certificate;
            if (!hasDoc) missing.push('Company Document (file upload)');

            const hasCertNo = values.registration_certificate_no && values.registration_certificate_no.trim();
            if (!hasCertNo) missing.push('Customs Certificate Number');
          }

          // RC Number required for all agents
          const hasRcNo = values.rc_no && values.rc_no.trim();
          if (!hasRcNo) missing.push('Company RC Number');

          // At least one director required
          const hasDirector = details.directors && details.directors.length > 0;
          if (!hasDirector) missing.push('Company Director (at least one must be added)');

          if (missing.length > 0) {
            dispatch(showModal(`Please complete the following fields before proceeding:\n• ${missing.join('\n• ')}`));
            return;
          }

          handleSubmit();
        };

        return (
          <form className="col-sm-9" onSubmit={handleSubmit}>
            <ClearingForwardingDocFields
              values={values}
              setFieldValue={setFieldValue}
              handleBlur={handleBlur}
              touched={touched}
              errors={errors}
              handleChange={handleChange}
              details={details}
              totalShareVal={totalShareVal}
              rightOpen={(type) => rightOpen(type, values)}
              editRight={(id, type) => editRight(id, type, values)}
              images={images}
              showDoc={showDoc}
              deleteRight={(id, type) => deleteRight(id, type, values)}
              userType={user.type}
              agentType={user.type}
            />
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <a className="next-model-button submitbut mt-5" onClick={validateAndNext}>
                Next
              </a>
            </div>
          </form>
        );
      }}
    </Formik>
  );
};

export default VerficationModalForm;
